// import $ from 'jquery'
import axios from "axios";
import BarChart from "../../components/BarChart.vue";
import PieChart from "../../components/PieChart.vue";
import CardSystem from "../../components/CardSystem.vue";
import moment from "moment";
import CardInfoBL from "../../components/CardInfoBL.vue";
import SelectClient from "../../components/SelectClient.vue";
import SelectBL from "../../components/SelectBL.vue";
import CardNavire from "../../components/CardNavire.vue";
import Header from "../../components/Header.vue";
import {fetchAcces} from "../../utils/fetchAcces";
// import moment from 'moment'

export default {
    components: {
        BarChart,
        PieChart,
        CardSystem,
        CardInfoBL,
        SelectClient,
        SelectBL,
        CardNavire,
        Header
    },
    data: function() {
        return {
            cardsData: [],
            clientList:[],
            dossier:[],
            navireList: [],
            list_acces: [],
            activeTab: 'suivieBL',
            pageTitle: "Tableau de Bord",
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            filtre:{
                date_debut:  moment().startOf('year').format('DD/MM/YYYY'),
                date_fin: moment().endOf('year').format('DD/MM/YYYY'),
                search: '',
                type_filtre: 'nom_client',
            },
            data:[],
            myPieData: {
                labels: ['Rouge', 'Bleu', 'Jaune', 'Vert'],
                dataSet: [50, 30, 20, 40],
                colors: ['#ff0000', '#0000ff', '#ffff00', '#00ff00']
            },
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 25,
            currentPageNavire: 1,
            totalPagesNavire: 1,
            itemsPerPageNavire: 24,
            is_developpeur: true,
            statutFiltre: ['en_cours', 'non_cloture'],
            statutLegende: [
                { value: 'cloture', label: 'Clôturé', colorClass: 'statut-cloture' },
                { value: 'en_cours', label: 'En cours', colorClass: 'statut-en-cours' },
                { value: 'non_cloture', label: 'Non clôturé', colorClass: 'statut-non-cloture' },
            ],
            filtreLiquide: false,
        }
    },
    computed: {
        pageNumbers() {
            return this.buildPaginationRange(this.currentPage, this.totalPages);
        },

        pageNumbersNavire() {
            return this.buildPaginationRange(this.currentPageNavire, this.totalPagesNavire);
        },

        canShowNombreDossierClient() {
            return this.hasAcces('nombre_dossier_par_client');
        },

        canShowSuivieDesBL() {
            return this.hasAcces('suivie_des_bl');
        },

        canShowNavire() {
            return this.hasAcces('navire');
        }
    },

    methods: {
        changeChoice(){
            this.filtre.search = '';
        },
        // Retourne les numeros de page a afficher, ex: [1,2,3,'...',48,49,50]
        buildPaginationRange(current, total) {
            total = total || 0;

            if (total <= 7) {
                const range = [];
                for (let i = 1; i <= total; i++) {
                    range.push(i);
                }
                return range;
            }

            const delta = 1;
            const pagesMap = {};
            const addPage = (p) => {
                if (p >= 1 && p <= total) {
                    pagesMap[p] = true;
                }
            };
            addPage(1); addPage(2); addPage(3);
            addPage(total - 2); addPage(total - 1); addPage(total);
            for (let i = current - delta; i <= current + delta; i++) {
                addPage(i);
            }

            const sorted = Object.keys(pagesMap)
                .map(p => parseInt(p, 10))
                .sort((a, b) => a - b);

            const result = [];
            let previous = null;
            for (let i = 0; i < sorted.length; i++) {
                const page = sorted[i];
                if (previous !== null && page - previous > 1) {
                    result.push('...');
                }
                result.push(page);
                previous = page;
            }

            return result;
        },
        setActiveTab(tabName) {
            if (this.activeTab !== tabName) {
                this.activeTab = tabName;
                if (tabName === 'suivieBL') {
                    this.getSuivieBL();
                } else if (tabName === 'navire') {
                    this.getNavire();
                }
            }
        },
        buildFiltreFormulaire(){
            let formulaire = new FormData();
            formulaire.append('date_debut',this.filtre.date_debut);
            formulaire.append('date_fin',this.filtre.date_fin);
            formulaire.append('search',this.filtre.search);
            formulaire.append('type_filtre',this.filtre.type_filtre);
            return formulaire;
        },
        getData(){
            let formulaire = this.buildFiltreFormulaire();

            axios.post(this.BASE_URL + '/dossier/dashboardGraphique',formulaire).then((response) => {
                this.clientList =response.data.graphique.client;
                this.cardsData = response.data.dasboard;
            })
        },
        getSuivieBL(){
            let formulaire = this.buildFiltreFormulaire();
            formulaire.append('page', this.currentPage);
            formulaire.append('per_page', this.itemsPerPage);
            this.statutFiltre.forEach(statut => formulaire.append('statuts[]', statut));
            formulaire.append('liquide', this.filtreLiquide ? 1 : 0);

            axios.post(this.BASE_URL + '/dossier/dashboardsuiviebl',formulaire).then((response) => {
                this.dossier = response.data.data;
                this.totalPages = response.data.last_page;
                this.currentPage = response.data.current_page;
            })
        },
        toggleStatutFiltre(statut) {
            const index = this.statutFiltre.indexOf(statut);
            if (index === -1) {
                this.statutFiltre.push(statut);
            } else {
                this.statutFiltre.splice(index, 1);
            }
            this.currentPage = 1;
            this.getSuivieBL();
        },
        toggleFiltreLiquide() {
            this.filtreLiquide = !this.filtreLiquide;
            this.currentPage = 1;
            this.getSuivieBL();
        },
        getNavire(){
            let formulaire = this.buildFiltreFormulaire();
            formulaire.append('page', this.currentPageNavire);
            formulaire.append('per_page', this.itemsPerPageNavire);

            axios.post(this.BASE_URL + '/dossier/dashboardnavire',formulaire).then((response) => {
                this.navireList = response.data.data;
                this.totalPagesNavire = response.data.last_page;
                this.currentPageNavire = response.data.current_page;
            })
        },
        setFilter() {
            this.currentPage = 1
            this.currentPageNavire = 1
            this.getData();
            this.getSuivieBL();
            this.getNavire();
        },
        resetFilter() {
            this.filtre={
                date_debut:  moment().startOf('year').format('DD/MM/YYYY'),
                date_fin: moment().endOf('year').format('DD/MM/YYYY'),
                search: '',
                type_filtre: 'nom_client',
            }
            this.setFilter();
        },
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
                this.getSuivieBL();
                // Optionnel: Remonter en haut de la liste lors du changement de page
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        changePageNavire(page) {
            if (page >= 1 && page <= this.totalPagesNavire) {
                this.currentPageNavire = page;
                this.getNavire();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },

        async fetchAcces(){
            const param = {
                titre_sous_module: 'tableau_de_bord'
            };
            let response = await fetchAcces({that: this, params: param});
            this.list_acces = response.data;
        },

        hasAcces(titre) {
            const acces = this.list_acces.find(
                a => a.titre_module_acces === titre
            );
            return acces ? acces.etat == 1 : false;
        }

    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";
    },
    mounted: async function() {
        this.getData();
        this.getSuivieBL();
        await this.fetchAcces()
    }
}
